import React from 'react';
import {Collapse as AntCollapse} from 'antd';
import './Collapse.less';
export default class Collapse extends AntCollapse {
    render(){
        return <AntCollapse {...this.props} className={`hms-collapse ${this.props.className || ''}`}>{this.props.children}</AntCollapse>
    }
}
export class Panel extends AntCollapse.Panel {
    render(){
        return <AntCollapse.Panel {...this.props} className={`hms-collapse-pane ${this.props.className || ''}`}>{this.props.children}</AntCollapse.Panel>
    }
}
Collapse.Panel = Panel;